// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================================
   Vokelle — Tasarım Sistemi
   Tek vurgu rengi (amber), near-black nötr zemin, tutarlı spacing/radius/shadow.
   Display: Space Grotesk · Body: Inter
   ========================================================================= */

:root {
  /* --- Nötr zemin (near-black charcoal) --- */
  --bg: #0a0a0b;
  --bg-1: #0e0e10;
  --surface: #141417;
  --surface-2: #1a1a1e;
  --surface-3: #212127;
  --glass: rgba(255, 255, 255, 0.028);
  --glass-strong: rgba(255, 255, 255, 0.045);

  /* --- Kenarlıklar --- */
  --border: rgba(255, 255, 255, 0.07);
  --border-strong: rgba(255, 255, 255, 0.12);
  --border-accent: rgba(255, 178, 36, 0.35);

  /* --- Metin --- */
  --text: #ededef;
  --text-2: #b4b4bd;
  --text-3: #82828c;
  --text-inverse: #16130c;

  /* --- Tek vurgu rengi: Amber --- */
  --accent: #ffb224;
  --accent-hover: #ffc457;
  --accent-press: #f0a412;
  --accent-soft: rgba(255, 178, 36, 0.12);
  --accent-soft-2: rgba(255, 178, 36, 0.18);
  --accent-glow: rgba(255, 178, 36, 0.28);

  /* --- Semantik (severity) — vurgudan ayrık tonlar --- */
  --ok: #3dd68c;
  --ok-soft: rgba(61, 214, 140, 0.14);
  --warn: #ffb224;
  --warn-soft: rgba(255, 178, 36, 0.14);
  --crit: #ff5c5c;
  --crit-soft: rgba(255, 92, 92, 0.14);
  --info: #6aa8ff;
  --info-soft: rgba(106, 168, 255, 0.14);

  /* --- Spacing ölçeği --- */
  --sp-1: 4px;
  --sp-2: 8px;
  --sp-3: 12px;
  --sp-4: 16px;
  --sp-5: 24px;
  --sp-6: 32px;
  --sp-7: 48px;
  --sp-8: 64px;
  --sp-9: 96px;

  /* --- Radius ölçeği --- */
  --r-sm: 8px;
  --r-md: 12px;
  --r-lg: 16px;
  --r-xl: 22px;
  --r-full: 999px;

  /* --- Gölge ölçeği (yumuşak, katmanlı) --- */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 16px -4px rgba(0, 0, 0, 0.4), 0 2px 6px -2px rgba(0, 0, 0, 0.3);
  --shadow-lg: 0 16px 48px -12px rgba(0, 0, 0, 0.55), 0 6px 16px -6px rgba(0, 0, 0, 0.4);
  --shadow-glow: 0 0 0 1px var(--border-accent), 0 8px 40px -8px var(--accent-glow);

  /* --- Layout --- */
  --maxw: 1120px;
  --nav-h: 68px;
  --sidebar-w: 244px;

  /* --- Hareket --- */
  --ease: cubic-bezier(0.22, 1, 0.36, 1);
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);
  --dur-fast: 0.14s;
  --dur: 0.24s;
  --dur-slow: 0.45s;

  color-scheme: dark;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-feature-settings: "cv05", "cv08", "ss01";
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

/* =========================================================================
   AÇIK TEMA — data-theme="light"
   ========================================================================= */
:root[data-theme="light"] {
  --bg: #f6f6f4;
  --bg-1: #ffffff;
  --surface: #ffffff;
  --surface-2: #f3f3f1;
  --surface-3: #e9e9e6;
  --glass: rgba(20, 20, 24, 0.022);
  --glass-strong: rgba(20, 20, 24, 0.04);

  --border: rgba(20, 20, 24, 0.1);
  --border-strong: rgba(20, 20, 24, 0.18);
  --border-accent: rgba(217, 130, 10, 0.4);

  --text: #1b1b1f;
  --text-2: #4c4c55;
  --text-3: #78787f;
  --text-inverse: #ffffff;

  --accent: #d9820a;
  --accent-hover: #c47408;
  --accent-press: #a86107;
  --accent-soft: rgba(217, 130, 10, 0.1);
  --accent-soft-2: rgba(217, 130, 10, 0.16);
  --accent-glow: rgba(217, 130, 10, 0.22);

  --ok: #17924f;
  --ok-soft: rgba(23, 146, 79, 0.12);
  --warn: #b26a00;
  --warn-soft: rgba(178, 106, 0, 0.13);
  --crit: #d13b3b;
  --crit-soft: rgba(209, 59, 59, 0.11);
  --info: #2f6fd0;
  --info-soft: rgba(47, 111, 208, 0.12);

  --shadow-sm: 0 1px 2px rgba(20, 20, 24, 0.06);
  --shadow-md: 0 4px 16px -4px rgba(20, 20, 24, 0.1), 0 2px 6px -2px rgba(20, 20, 24, 0.06);
  --shadow-lg: 0 16px 48px -12px rgba(20, 20, 24, 0.16), 0 6px 16px -6px rgba(20, 20, 24, 0.1);

  color-scheme: light;
}

:root[data-theme="light"] body {
  background-image:
    radial-gradient(900px 500px at 15% -8%, rgba(217, 130, 10, 0.07), transparent 60%),
    radial-gradient(700px 600px at 100% 0%, rgba(47, 111, 208, 0.05), transparent 55%);
}

/* Hero mesh koyu için tasarlandı; açık temada çarpım harmanı + düşük opaklık */
:root[data-theme="light"] .hero-mesh {
  opacity: 0.3;
}
:root[data-theme="light"] .hero-mesh span {
  mix-blend-mode: multiply;
}
:root[data-theme="light"] .nav.scrolled {
  background: rgba(255, 255, 255, 0.8);
}
:root[data-theme="light"] .app-topbar {
  background: rgba(255, 255, 255, 0.75);
}
:root[data-theme="light"] .avatar {
  background: var(--accent-soft-2);
}
:root[data-theme="light"] .hero-visual {
  background: linear-gradient(180deg, rgba(20, 20, 24, 0.03), rgba(20, 20, 24, 0.01));
}
:root[data-theme="light"] .sidebar {
  background: var(--surface-2);
}
:root[data-theme="light"] .site-footer {
  background: var(--bg-1);
}

* {
  box-sizing: border-box;
  margin: 0;
}

html,
body,
#root {
  min-height: 100%;
}

body {
  background: var(--bg);
  color: var(--text);
  line-height: 1.6;
  font-size: 15px;
  /* Zemin üzerinde çok hafif atmosfer */
  background-image:
    radial-gradient(900px 500px at 15% -8%, rgba(255, 178, 36, 0.05), transparent 60%),
    radial-gradient(700px 600px at 100% 0%, rgba(106, 168, 255, 0.035), transparent 55%);
  background-attachment: fixed;
}

::selection {
  background: var(--accent-soft-2);
  color: var(--text);
}

h1,
h2,
h3,
h4 {
  font-family: "Space Grotesk", "Inter", sans-serif;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.12;
  color: var(--text);
}

a {
  color: var(--text);
  text-decoration: none;
  transition: color var(--dur-fast) var(--ease);
}
a:hover {
  color: var(--accent);
}

p {
  color: var(--text-2);
}

:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
  border-radius: 4px;
}

/* =========================================================================
   Layout yardımcıları
   ========================================================================= */

.container {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 0 var(--sp-5);
}

.page-enter {
  animation: fadeInUp var(--dur-slow) var(--ease-out) both;
}

/* Scroll-reveal */
.reveal {
  opacity: 0;
  transform: translateY(18px);
  transition: opacity 0.6s var(--ease-out), transform 0.6s var(--ease-out);
}
.reveal.revealed {
  opacity: 1;
  transform: none;
}
.reveal.d1 { transition-delay: 0.06s; }
.reveal.d2 { transition-delay: 0.12s; }
.reveal.d3 { transition-delay: 0.18s; }
.reveal.d4 { transition-delay: 0.24s; }
@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1; transform: none; transition: none; }
}

.stack {
  display: flex;
  flex-direction: column;
}

.eyebrow {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--accent);
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
}
.eyebrow::before {
  content: "";
  width: 18px;
  height: 1px;
  background: var(--accent);
  opacity: 0.6;
}

/* =========================================================================
   Marka
   ========================================================================= */

.brand {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-family: "Space Grotesk", sans-serif;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.02em;
  color: var(--text);
}
.brand:hover {
  color: var(--text);
}
.brand svg {
  flex-shrink: 0;
}

/* =========================================================================
   Butonlar
   ========================================================================= */

.btn {
  --btn-bg: var(--accent);
  --btn-fg: var(--text-inverse);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  padding: 10px 18px;
  border-radius: var(--r-md);
  border: 1px solid transparent;
  background: var(--btn-bg);
  color: var(--btn-fg);
  font-family: inherit;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  transition: transform var(--dur-fast) var(--ease), background var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease), border-color var(--dur) var(--ease), opacity var(--dur) var(--ease);
}
.btn:hover {
  background: var(--accent-hover);
  color: var(--text-inverse);
  box-shadow: 0 6px 24px -8px var(--accent-glow);
}
.btn:active {
  transform: translateY(1px) scale(0.985);
  background: var(--accent-press);
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-ghost {
  --btn-bg: transparent;
  --btn-fg: var(--text);
  border-color: var(--border-strong);
}
.btn-ghost:hover {
  --btn-bg: var(--glass-strong);
  color: var(--text);
  border-color: var(--border-strong);
  box-shadow: none;
}
.btn-ghost:active {
  background: var(--surface-2);
}

.btn-subtle {
  --btn-bg: var(--surface-2);
  --btn-fg: var(--text);
  border-color: var(--border);
}
.btn-subtle:hover {
  --btn-bg: var(--surface-3);
  color: var(--text);
  box-shadow: none;
}

.btn-sm {
  padding: 7px 13px;
  font-size: 13px;
  border-radius: var(--r-sm);
}
.btn-lg {
  padding: 13px 24px;
  font-size: 15px;
}
.btn-block {
  width: 100%;
}

/* =========================================================================
   Kartlar / yüzeyler (glass)
   ========================================================================= */

.card {
  background: var(--glass);
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  padding: var(--sp-5);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  transition: transform var(--dur) var(--ease), border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease), background var(--dur) var(--ease);
}
.card-hover:hover {
  transform: translateY(-3px);
  border-color: var(--border-strong);
  box-shadow: var(--shadow-lg);
  background: var(--glass-strong);
}

.panel {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-md);
}

/* =========================================================================
   Rozetler / chip'ler
   ========================================================================= */

.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: var(--r-full);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border: 1px solid var(--border);
  color: var(--text-2);
  background: var(--glass);
}
.badge.ok {
  color: var(--ok);
  background: var(--ok-soft);
  border-color: transparent;
}
.badge.warn {
  color: var(--warn);
  background: var(--warn-soft);
  border-color: transparent;
}
.badge.crit {
  color: var(--crit);
  background: var(--crit-soft);
  border-color: transparent;
}
.badge.info {
  color: var(--info);
  background: var(--info-soft);
  border-color: transparent;
}

/* =========================================================================
   Nabız / durum göstergesi
   ========================================================================= */

.pulse {
  position: relative;
  display: inline-flex;
  width: 9px;
  height: 9px;
  flex-shrink: 0;
}
.pulse::before,
.pulse::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
}
.pulse::before {
  background: var(--dot, var(--text-3));
  box-shadow: 0 0 8px var(--dot, transparent);
}
.pulse::after {
  background: var(--dot, var(--text-3));
  animation: pulse-ring 2.4s var(--ease-out) infinite;
}
.pulse.is-static::after {
  display: none;
}
.pulse.ok {
  --dot: var(--ok);
}
.pulse.warn {
  --dot: var(--warn);
}
.pulse.crit {
  --dot: var(--crit);
}
.pulse.idle {
  --dot: var(--text-3);
}

.status-line {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  font-size: 13px;
  color: var(--text-2);
}

/* =========================================================================
   Marketing navigasyonu
   ========================================================================= */

.nav {
  position: sticky;
  top: 0;
  z-index: 40;
  height: var(--nav-h);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--sp-5);
  border-bottom: 1px solid transparent;
  background: rgba(10, 10, 11, 0);
  transition: background var(--dur) var(--ease), border-color var(--dur) var(--ease);
}
.nav.scrolled {
  background: rgba(10, 10, 11, 0.72);
  border-bottom-color: var(--border);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.nav .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}
.nav-links .link {
  font-size: 14px;
  color: var(--text-2);
  font-weight: 450;
}
.nav-links .link:hover {
  color: var(--text);
}

/* =========================================================================
   Dil değiştirici
   ========================================================================= */

.lang-toggle {
  display: inline-flex;
  padding: 3px;
  border: 1px solid var(--border);
  border-radius: var(--r-full);
  background: var(--glass);
  gap: 2px;
}
.lang-toggle button {
  background: transparent;
  color: var(--text-3);
  border: 0;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  cursor: pointer;
  border-radius: var(--r-full);
  transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);
}
.lang-toggle button:hover {
  color: var(--text-2);
}
.lang-toggle button.active {
  background: var(--accent);
  color: var(--text-inverse);
}

/* Tema değiştirici */
.theme-toggle {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--border);
  border-radius: var(--r-full);
  background: var(--glass);
  color: var(--text-2);
  cursor: pointer;
  transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease), border-color var(--dur-fast) var(--ease);
}
.theme-toggle:hover {
  color: var(--accent);
  border-color: var(--border-accent);
}

/* =========================================================================
   Hero
   ========================================================================= */

.hero {
  position: relative;
  padding: var(--sp-9) 0 var(--sp-8);
  overflow: hidden;
}
.hero-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: var(--sp-7);
  align-items: center;
}
.hero h1 {
  font-size: clamp(2.4rem, 5vw, 3.5rem);
  margin: var(--sp-4) 0 var(--sp-4);
}
.hero .lede {
  font-size: 1.075rem;
  color: var(--text-2);
  max-width: 30rem;
  margin-bottom: var(--sp-5);
}
.hero-actions {
  display: flex;
  gap: var(--sp-3);
  flex-wrap: wrap;
}
.hero-trust {
  margin-top: var(--sp-6);
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  color: var(--text-3);
  font-size: 13px;
}
.hero-trust .dot-sep {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: var(--text-3);
}

/* Hero arkaplan blob mesh */
.hero-mesh {
  position: absolute;
  inset: -20% -10% auto -10%;
  height: 640px;
  z-index: 1;
  pointer-events: none;
  filter: blur(90px);
  opacity: 0.55;
}
.hero-mesh span {
  position: absolute;
  border-radius: 50%;
  mix-blend-mode: screen;
}
.hero-mesh .b1 {
  width: 420px;
  height: 420px;
  left: 4%;
  top: 8%;
  background: radial-gradient(circle at 30% 30%, #ffb224, transparent 70%);
  animation: drift1 16s ease-in-out infinite alternate;
}
.hero-mesh .b2 {
  width: 380px;
  height: 380px;
  right: 10%;
  top: 0%;
  background: radial-gradient(circle at 60% 40%, #6aa8ff, transparent 70%);
  animation: drift2 20s ease-in-out infinite alternate;
}
.hero-mesh .b3 {
  width: 320px;
  height: 320px;
  right: 26%;
  top: 40%;
  background: radial-gradient(circle at 50% 50%, #ff7d5c, transparent 72%);
  opacity: 0.7;
  animation: drift3 24s ease-in-out infinite alternate;
}

/* Hero görsel kartı (sinyal / nabız) */
.hero-visual {
  position: relative;
  border: 1px solid var(--border);
  border-radius: var(--r-xl);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: var(--shadow-lg);
  padding: var(--sp-5);
  overflow: hidden;
}
.hero-visual .hv-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--sp-4);
}
.hero-visual .hv-title {
  font-size: 13px;
  color: var(--text-3);
  font-weight: 500;
}
.hero-visual svg {
  display: block;
  width: 100%;
  height: auto;
}

/* =========================================================================
   Bölümler
   ========================================================================= */

.section {
  padding: var(--sp-9) 0;
}
.section-head {
  max-width: 40rem;
  margin: 0 auto var(--sp-7);
  text-align: center;
}
.section-head h2 {
  font-size: clamp(1.7rem, 3vw, 2.2rem);
  margin: var(--sp-3) 0 var(--sp-3);
}
.section-head p {
  color: var(--text-2);
}

.divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-strong), transparent);
}

/* Özellik ızgarası */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(248px, 1fr));
  gap: var(--sp-4);
}
.feature {
  padding: var(--sp-5);
}
.feature .ico {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: var(--r-md);
  background: var(--accent-soft);
  color: var(--accent);
  margin-bottom: var(--sp-4);
}
.feature h3 {
  font-size: 1.05rem;
  margin-bottom: var(--sp-2);
}
.feature p {
  font-size: 0.925rem;
  color: var(--text-2);
}

/* Nasıl çalışır */
.steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--sp-4);
  counter-reset: step;
}
.step {
  position: relative;
  padding: var(--sp-5);
}
.step .num {
  font-family: "Space Grotesk", sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: var(--accent);
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: var(--r-full);
  border: 1px solid var(--border-accent);
  background: var(--accent-soft);
  margin-bottom: var(--sp-3);
}
.step p {
  font-size: 0.95rem;
}

/* Fiyatlandırma */
.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--sp-4);
}
.price-card {
  text-align: center;
  padding: var(--sp-6) var(--sp-5);
  position: relative;
}
.price-card.featured {
  border-color: var(--border-accent);
  box-shadow: var(--shadow-glow);
}
.price-card .tag {
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-inverse);
  background: var(--accent);
  padding: 3px 10px;
  border-radius: var(--r-full);
}
.price-card .plan-name {
  font-family: "Space Grotesk", sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: var(--sp-2);
}
.price-card .plan-hint {
  font-size: 0.85rem;
  color: var(--text-3);
  margin-bottom: var(--sp-4);
}
.pricing-note {
  text-align: center;
  color: var(--text-3);
  font-size: 0.9rem;
  margin-top: var(--sp-6);
  max-width: 34rem;
  margin-left: auto;
  margin-right: auto;
}

/* Problem / çözüm */
.pain-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-4);
  margin-bottom: var(--sp-6);
}
.pain-card {
  padding: var(--sp-6);
  border-color: rgba(255, 92, 92, 0.18);
}
.pain-card .pain-ico {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: var(--r-md);
  background: var(--crit-soft);
  color: var(--crit);
  margin-bottom: var(--sp-4);
}
.solution-band {
  padding: var(--sp-6);
  border-radius: var(--r-xl);
  border: 1px solid var(--border-accent);
  background: radial-gradient(600px 200px at 50% 0%, var(--accent-soft), transparent 70%), var(--surface);
  text-align: center;
}
.solution-band h3 {
  font-size: 1.3rem;
  margin-bottom: var(--sp-3);
}

/* Neyi yakalar — metrik detay */
.detect-list {
  display: grid;
  gap: var(--sp-4);
}
.detect-row {
  display: grid;
  grid-template-columns: 48px 1fr;
  gap: var(--sp-4);
  padding: var(--sp-5);
  align-items: start;
}
.detect-row .d-ico {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: var(--r-md);
  background: var(--accent-soft);
  color: var(--accent);
}
.detect-row .d-ico.tone-players { background: var(--info-soft); color: var(--info); }
.detect-row .d-ico.tone-cheat { background: var(--crit-soft); color: var(--crit); }
.detect-row .d-ico.tone-content { background: var(--ok-soft); color: var(--ok); }
.detect-row h3 {
  font-size: 1.05rem;
  margin-bottom: 4px;
}
.detect-row p {
  font-size: 0.93rem;
  margin-bottom: 0;
}

/* FAQ */
.faq {
  max-width: 44rem;
  margin: 0 auto;
}
.faq-item {
  border-bottom: 1px solid var(--border);
}
.faq-q {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-4) 0;
  background: none;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  color: var(--text);
  text-align: left;
}
.faq-q svg { color: var(--text-3); flex-shrink: 0; transition: color var(--dur-fast) var(--ease); }
.faq-item.open .faq-q svg { color: var(--accent); }
.faq-a {
  overflow: hidden;
  transition: max-height var(--dur) var(--ease);
}
.faq-a p {
  padding: 0 0 var(--sp-4);
  color: var(--text-2);
  font-size: 0.94rem;
  line-height: 1.65;
  margin: 0;
}

/* Kurumsal footer */
.corp-footer {
  border-top: 1px solid var(--border);
  background: var(--bg-1);
  padding: var(--sp-8) 0 var(--sp-6);
  margin-top: var(--sp-9);
}
.corp-footer .cols {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr;
  gap: var(--sp-6);
  margin-bottom: var(--sp-7);
}
.corp-footer .col h4 {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-3);
  margin-bottom: var(--sp-4);
}
.corp-footer .col a,
.corp-footer .col p {
  display: block;
  color: var(--text-2);
  font-size: 13.5px;
  margin-bottom: 10px;
}
.corp-footer .col a:hover { color: var(--accent); }
.corp-footer .brand-col p {
  color: var(--text-3);
  max-width: 22rem;
  margin-top: var(--sp-3);
}
.corp-footer .bottom {
  border-top: 1px solid var(--border);
  padding-top: var(--sp-5);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--sp-3);
  color: var(--text-3);
  font-size: 12.5px;
}

/* CTA şeridi */
.cta-band {
  text-align: center;
  padding: var(--sp-8) var(--sp-6);
  border-radius: var(--r-xl);
  border: 1px solid var(--border-accent);
  background:
    radial-gradient(600px 200px at 50% 0%, var(--accent-soft), transparent 70%),
    var(--surface);
  box-shadow: var(--shadow-md);
}
.cta-band h2 {
  font-size: clamp(1.6rem, 3vw, 2rem);
  margin-bottom: var(--sp-3);
}
.cta-band p {
  margin-bottom: var(--sp-5);
}

/* Footer */
.site-footer {
  border-top: 1px solid var(--border);
  padding: var(--sp-6) 0;
  margin-top: var(--sp-8);
}
.site-footer .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--sp-3);
  color: var(--text-3);
  font-size: 13px;
}

/* =========================================================================
   Auth ekranları
   ========================================================================= */

.auth-screen {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.auth-aside {
  position: relative;
  padding: var(--sp-8) var(--sp-7);
  border-right: 1px solid var(--border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    radial-gradient(700px 400px at 20% 10%, rgba(255, 178, 36, 0.08), transparent 60%),
    radial-gradient(600px 500px at 90% 90%, rgba(106, 168, 255, 0.06), transparent 60%),
    var(--bg-1);
}
.auth-aside .aside-body {
  margin-top: auto;
  max-width: 26rem;
}
.auth-aside h2 {
  font-size: 1.9rem;
  margin: var(--sp-4) 0 var(--sp-3);
}
.auth-aside p {
  color: var(--text-2);
}
.auth-aside .aside-visual {
  position: absolute;
  right: -60px;
  top: 50%;
  transform: translateY(-50%);
  width: 420px;
  opacity: 0.5;
  pointer-events: none;
}

.auth-main {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-7) var(--sp-5);
}
.auth-card {
  width: 100%;
  max-width: 384px;
}
.auth-card .auth-head {
  margin-bottom: var(--sp-5);
}
.auth-card h1 {
  font-size: 1.5rem;
  margin-bottom: var(--sp-2);
}
.auth-card .sub {
  color: var(--text-3);
  font-size: 0.9rem;
}

.field {
  margin-bottom: var(--sp-4);
}
.field label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-2);
  margin-bottom: 6px;
}
.field .control {
  position: relative;
}
.field input {
  width: 100%;
  padding: 11px 13px;
  border-radius: var(--r-md);
  border: 1px solid var(--border-strong);
  background: var(--bg-1);
  color: var(--text);
  font-family: inherit;
  font-size: 14px;
  transition: border-color var(--dur) var(--ease), box-shadow var(--dur) var(--ease), background var(--dur) var(--ease);
}
.field input::placeholder {
  color: var(--text-3);
}
.field input:hover {
  border-color: var(--border-strong);
}
.field input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
  background: var(--surface);
}
.field .hint {
  font-size: 12px;
  color: var(--text-3);
  margin-top: 5px;
}

.form-error {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-2);
  background: var(--crit-soft);
  border: 1px solid rgba(255, 92, 92, 0.3);
  color: #ffb3b3;
  padding: 10px 12px;
  border-radius: var(--r-md);
  font-size: 13px;
  margin-bottom: var(--sp-4);
  animation: fadeInUp var(--dur) var(--ease-out) both;
}

.auth-alt {
  margin-top: var(--sp-5);
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
  font-size: 13px;
  color: var(--text-3);
  text-align: center;
}
.auth-alt a {
  color: var(--accent);
  font-weight: 500;
}

.auth-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--sp-7);
}

/* =========================================================================
   Uygulama kabuğu (dashboard / admin)
   ========================================================================= */

.app-shell {
  display: grid;
  grid-template-columns: var(--sidebar-w) 1fr;
  min-height: 100vh;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  border-right: 1px solid var(--border);
  background: var(--bg-1);
  padding: var(--sp-5) var(--sp-3);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}
.sidebar .brand {
  padding: 0 var(--sp-3) var(--sp-5);
}
.sidebar .nav-group-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-3);
  padding: var(--sp-3) var(--sp-3) var(--sp-2);
}
.sidebar nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.side-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px var(--sp-3);
  border-radius: var(--r-sm);
  color: var(--text-3);
  font-size: 13.5px;
  font-weight: 450;
  position: relative;
  transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);
}
.side-link svg {
  width: 16px;
  height: 16px;
  opacity: 0.8;
}
.side-link:hover {
  color: var(--text);
  background: var(--glass);
}
.side-link.active {
  color: var(--text);
  background: var(--glass-strong);
}
.side-link.active::before {
  content: "";
  position: absolute;
  left: calc(-1 * var(--sp-3));
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 18px;
  border-radius: var(--r-full);
  background: var(--accent);
}
.sidebar .side-foot {
  margin-top: auto;
  padding: var(--sp-3);
  border-top: 1px solid var(--border);
}

.app-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.app-topbar {
  height: var(--nav-h);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--sp-6);
  border-bottom: 1px solid var(--border);
  background: rgba(10, 10, 11, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: 20;
}
.app-topbar .crumb {
  font-size: 13px;
  color: var(--text-3);
}
.app-topbar .crumb strong {
  color: var(--text);
  font-weight: 600;
}
.topbar-right {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}
.avatar {
  width: 30px;
  height: 30px;
  border-radius: var(--r-full);
  display: grid;
  place-items: center;
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--border-accent);
}

@media (max-width: 560px) {
  .logout-label {
    display: none;
  }
}

.app-body {
  padding: var(--sp-6);
  max-width: 1160px;
  width: 100%;
}
.app-body > .page-title {
  font-size: 1.6rem;
  margin-bottom: 4px;
}
.app-body > .page-sub {
  color: var(--text-3);
  font-size: 0.92rem;
  margin-bottom: var(--sp-6);
}

/* İstatistik kartları */
.stat-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: var(--sp-4);
  margin-bottom: var(--sp-5);
}
.stat {
  padding: var(--sp-5);
}
.stat .stat-label {
  font-size: 12px;
  color: var(--text-3);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: var(--sp-3);
}
.stat .stat-value {
  font-family: "Space Grotesk", sans-serif;
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.stat .stat-meta {
  margin-top: var(--sp-3);
  font-size: 12px;
  color: var(--text-3);
}
.stat .stat-meta .up {
  color: var(--ok);
}
.stat .stat-meta .down {
  color: var(--crit);
}

/* Grafik kartı */
.chart-card {
  padding: var(--sp-5);
  margin-bottom: var(--sp-4);
}
.chart-card .chart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--sp-4);
}
.chart-card .chart-head h3 {
  font-size: 1rem;
}
.chart-canvas {
  width: 100%;
}

/* Boş durum */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--sp-8) var(--sp-6);
  border: 1px dashed var(--border-strong);
  border-radius: var(--r-lg);
  background: var(--glass);
}
.empty-state svg {
  margin-bottom: var(--sp-4);
}
.empty-state h3 {
  font-size: 1.05rem;
  margin-bottom: var(--sp-2);
}
.empty-state p {
  color: var(--text-3);
  font-size: 0.92rem;
  max-width: 26rem;
}

/* Liste (alarmlar vb.) */
.list {
  display: flex;
  flex-direction: column;
}
.list-row {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-4);
  border-bottom: 1px solid var(--border);
  font-size: 13.5px;
}
.list-row:last-child {
  border-bottom: 0;
}
.list-row .row-main {
  flex: 1;
  min-width: 0;
}
.list-row .row-time {
  color: var(--text-3);
  font-size: 12px;
  white-space: nowrap;
}

/* =========================================================================
   Skeleton yükleme
   ========================================================================= */

.skeleton {
  position: relative;
  overflow: hidden;
  background: var(--surface-2);
  border-radius: var(--r-sm);
}
.skeleton::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.06), transparent);
  animation: shimmer 1.6s infinite;
}
.sk-text {
  height: 12px;
  margin: 6px 0;
}
.sk-title {
  height: 20px;
  width: 40%;
  margin-bottom: 12px;
}
.sk-value {
  height: 32px;
  width: 55%;
}
.sk-block {
  height: 180px;
  border-radius: var(--r-md);
}

/* =========================================================================
   Keyframes
   ========================================================================= */

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  70% {
    transform: scale(2.6);
    opacity: 0;
  }
  100% {
    transform: scale(2.6);
    opacity: 0;
  }
}

@keyframes drift1 {
  to {
    transform: translate(40px, 30px) scale(1.1);
  }
}
@keyframes drift2 {
  to {
    transform: translate(-50px, 20px) scale(1.08);
  }
}
@keyframes drift3 {
  to {
    transform: translate(30px, -40px) scale(1.12);
  }
}

@keyframes dash-flow {
  to {
    stroke-dashoffset: -1000;
  }
}

@keyframes trace {
  from {
    stroke-dashoffset: 1200;
  }
  to {
    stroke-dashoffset: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}

/* =========================================================================
   Responsive
   ========================================================================= */

@media (max-width: 960px) {
  .hero-grid {
    grid-template-columns: 1fr;
    gap: var(--sp-6);
  }
  .hero-visual {
    order: -1;
  }
  .steps,
  .pricing-grid,
  .pain-grid {
    grid-template-columns: 1fr;
  }
  .corp-footer .cols {
    grid-template-columns: 1fr 1fr;
    gap: var(--sp-5);
  }
  .auth-screen {
    grid-template-columns: 1fr;
  }
  .auth-aside {
    display: none;
  }
}

@media (max-width: 560px) {
  .corp-footer .cols {
    grid-template-columns: 1fr;
  }
  .detect-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 820px) {
  .app-shell {
    grid-template-columns: 1fr;
  }
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 60;
    transform: translateX(-100%);
    transition: transform var(--dur) var(--ease);
    width: var(--sidebar-w);
    box-shadow: var(--shadow-lg);
  }
  .sidebar.open {
    transform: translateX(0);
  }
  .app-body {
    padding: var(--sp-4);
  }
  .nav-links .link {
    display: none;
  }
}

@media (max-width: 560px) {
  .container {
    padding: 0 var(--sp-4);
  }
  .hero {
    padding: var(--sp-7) 0 var(--sp-6);
  }
  .section {
    padding: var(--sp-7) 0;
  }
}

.menu-btn {
  display: none;
  background: transparent;
  border: 1px solid var(--border-strong);
  border-radius: var(--r-sm);
  color: var(--text);
  padding: 6px;
  cursor: pointer;
}
@media (max-width: 820px) {
  .menu-btn {
    display: inline-grid;
    place-items: center;
  }
}

.scrim {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 55;
  backdrop-filter: blur(2px);
}
@media (min-width: 821px) {
  .scrim {
    display: none;
  }
}

/* =========================================================================
   Faz 8 — Zengin metrik paneli
   ========================================================================= */

.dash-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-4);
  flex-wrap: wrap;
  margin-bottom: var(--sp-5);
}
.agent-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: var(--r-full);
  border: 1px solid var(--border);
  background: var(--glass);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.agent-pill .ap-time {
  color: var(--text-3);
  font-weight: 400;
  font-size: 12px;
  padding-left: 6px;
  border-left: 1px solid var(--border);
}

.health-card {
  display: flex;
  align-items: center;
  gap: var(--sp-6);
  flex-wrap: wrap;
  margin-bottom: var(--sp-4);
}
.health-body {
  flex: 1;
  min-width: 240px;
}
.health-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: "Space Grotesk", sans-serif;
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 4px;
}
.health-desc {
  color: var(--text-3);
  font-size: 0.9rem;
  margin: 0 0 12px;
  max-width: 44ch;
}
.health-drivers {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.health-drivers li {
  display: flex;
  align-items: baseline;
  gap: 10px;
  font-size: 13px;
  color: var(--text-2);
}
.health-drivers .hd-pts {
  font-family: "Space Grotesk", sans-serif;
  font-variant-numeric: tabular-nums;
  color: var(--crit);
  font-weight: 600;
  min-width: 30px;
  text-align: right;
}
.hd-clean {
  font-size: 13px;
  color: var(--ok);
  margin: 0;
}
.health-spark {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
  font-size: 11px;
  color: var(--text-3);
}

.schema-strip {
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  background: var(--glass);
  margin-bottom: var(--sp-6);
  overflow: hidden;
}
.schema-strip .ss-head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: transparent;
  border: 0;
  color: var(--text-2);
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
}
.schema-strip .ss-body {
  padding: 0 14px 14px;
  font-size: 12.5px;
  color: var(--text-3);
}
.schema-strip .ss-body p {
  margin: 0 0 10px;
}
.ss-missing {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.ss-missing code {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  padding: 2px 7px;
  font-size: 11.5px;
}

.metric-section {
  margin-bottom: var(--sp-7);
}
.ms-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Space Grotesk", sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--text-2);
  margin-bottom: var(--sp-4);
}
.ms-title svg { color: var(--text-3); }
.ms-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--sp-4);
}
.ms-title-row .ms-title {
  margin-bottom: 0;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
  gap: var(--sp-3);
}
.mc-wrap.wide {
  grid-column: span 2;
}
.mc-wrap {
  display: flex;
  flex-direction: column;
}

.metric-card {
  background: var(--glass);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  padding: var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  transition: border-color var(--dur) var(--ease), transform var(--dur) var(--ease);
}
.mc-wrap:hover .metric-card {
  border-color: var(--border-strong);
}
.mc-wrap.wide .metric-card {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 0;
}
.mc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.mc-label {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  color: var(--text-3);
  font-weight: 500;
  line-height: 1.3;
}
.mc-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}
.mc-delta {
  font-size: 11.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.mc-delta.up { color: var(--ok); }
.mc-delta.down { color: var(--crit); }
.mc-delta.flat { color: var(--text-3); }
.mc-value {
  font-family: "Space Grotesk", sans-serif;
  font-size: 1.55rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.mc-spark {
  margin-top: auto;
}
.mc-foot {
  font-size: 11px;
  color: var(--text-3);
}
.mc-detail {
  border: 1px solid var(--border);
  border-top: 0;
  border-bottom-left-radius: var(--r-md);
  border-bottom-right-radius: var(--r-md);
  background: var(--surface);
  padding: var(--sp-4);
}

/* MiniBars */
.mb-track {
  display: flex;
  height: 12px;
  border-radius: var(--r-full);
  overflow: hidden;
  background: var(--surface-2);
}
.mb-fill {
  height: 100%;
}
.mb-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin-top: 10px;
  font-size: 11.5px;
  color: var(--text-3);
}
.mb-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.mb-legend i {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}
.mb-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mb-row {
  display: grid;
  grid-template-columns: 68px 1fr auto;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}
.mb-row-label {
  color: var(--text-3);
}
.mb-row-track {
  height: 8px;
  background: var(--surface-2);
  border-radius: var(--r-full);
  overflow: hidden;
}
.mb-row-val {
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
  font-size: 11.5px;
}

@media (max-width: 720px) {
  .metric-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
  .mc-wrap.wide {
    grid-column: 1 / -1;
  }
  .health-card {
    gap: var(--sp-4);
  }
  .health-spark {
    display: none;
  }
}

/* =========================================================================
   Yasal sayfalar
   ========================================================================= */

.legal-page {
  padding: calc(var(--nav-h, 64px) + var(--sp-8)) 0 var(--sp-8);
  max-width: 820px;
  margin: 0 auto;
}
.legal-page .legal-back {
  display: inline-block;
  color: var(--text-3);
  font-size: 13px;
  margin-bottom: var(--sp-5);
}
.legal-page .legal-back:hover { color: var(--accent); }
.legal-page h1 {
  font-size: 2rem;
  margin-bottom: 6px;
}
.legal-page .legal-updated {
  color: var(--text-3);
  font-size: 13px;
  margin-bottom: var(--sp-5);
}
.legal-page .legal-intro {
  color: var(--text-2);
  font-size: 1rem;
  line-height: 1.7;
  padding-bottom: var(--sp-5);
  border-bottom: 1px solid var(--border);
  margin-bottom: var(--sp-6);
}
.legal-section {
  margin-bottom: var(--sp-6);
}
.legal-section h2 {
  font-size: 1.08rem;
  margin-bottom: var(--sp-3);
}
.legal-section p {
  color: var(--text-2);
  font-size: 0.95rem;
  line-height: 1.75;
  margin-bottom: var(--sp-3);
}
.legal-section ul {
  margin: var(--sp-2) 0 var(--sp-3) var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.legal-section li {
  color: var(--text-2);
  font-size: 0.95rem;
  line-height: 1.65;
  list-style: disc;
}
.legal-nav {
  display: flex;
  gap: var(--sp-3);
  flex-wrap: wrap;
  padding-top: var(--sp-6);
  border-top: 1px solid var(--border);
  margin-top: var(--sp-7);
}

@media (max-width: 560px) {
  .legal-page h1 { font-size: 1.5rem; }
}

/* =========================================================================
   Faz 9 — Çoklu sunucu
   ========================================================================= */

/* Topbar sunucu seçici */
.srv-switch { position: relative; }
.srv-switch-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: var(--r-full);
  border: 1px solid var(--border);
  background: var(--glass);
  color: var(--text);
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  max-width: 200px;
}
.srv-switch-btn:hover { border-color: var(--border-strong); }
.srv-switch-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.srv-switch-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 240px;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-md);
  box-shadow: var(--shadow-lg);
  padding: 6px;
  z-index: 40;
}
.srv-switch-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border: 0;
  border-radius: var(--r-sm);
  background: transparent;
  color: var(--text-2);
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
}
.srv-switch-item:hover { background: var(--surface-2); color: var(--text); }
.srv-switch-item.active { color: var(--text); background: var(--accent-soft); }
.srv-switch-item span:nth-child(2) { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.srv-switch-foot {
  display: flex;
  gap: 4px;
  border-top: 1px solid var(--border);
  margin-top: 4px;
  padding-top: 4px;
}
.srv-switch-foot button {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 8px;
  border: 0;
  border-radius: var(--r-sm);
  background: transparent;
  color: var(--text-3);
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}
.srv-switch-foot button:hover { background: var(--surface-2); color: var(--text); }

.srv-tag {
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: var(--r-full);
  background: var(--surface-3);
  color: var(--text-3);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.srv-tag.warn { background: var(--warn-soft); color: var(--warn); }
.srv-health {
  font-family: "Space Grotesk", sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  padding: 2px 7px;
  border-radius: var(--r-full);
  background: var(--ok-soft);
  color: var(--ok);
}
.srv-health.warn { background: var(--warn-soft); color: var(--warn); }
.srv-health.crit { background: var(--crit-soft); color: var(--crit); }

/* Sunucularım listesi */
.list-plain { display: flex; flex-direction: column; gap: var(--sp-3); }
.srv-row { padding: 0; overflow: hidden; }
.srv-row.is-suspended { opacity: 0.7; }
.srv-row-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
  padding: var(--sp-4);
  flex-wrap: wrap;
}
.srv-row-body {
  border-top: 1px solid var(--border);
  padding: var(--sp-4);
  background: var(--bg-1);
}
.srv-setup-warn {
  color: var(--warn);
  font-size: 12.5px;
  margin: 0 0 12px;
}
.icon-btn {
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: transparent;
  color: var(--text-3);
  cursor: pointer;
}
.icon-btn:hover { color: var(--accent); border-color: var(--border-strong); }

/* Adet seçici */
.qty-stepper {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--border-strong);
  border-radius: var(--r-md);
  overflow: hidden;
}
.qty-stepper button {
  width: 38px;
  height: 38px;
  border: 0;
  background: var(--surface-2);
  color: var(--text);
  font-size: 18px;
  cursor: pointer;
}
.qty-stepper button:hover:not(:disabled) { background: var(--surface-3); }
.qty-stepper button:disabled { opacity: 0.4; cursor: not-allowed; }
.qty-stepper span {
  min-width: 44px;
  text-align: center;
  font-family: "Space Grotesk", sans-serif;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

/* --- Büyüme / Reklam Atıf --- */
.fld { display: flex; flex-direction: column; gap: 5px; font-size: 12px; }
.fld > span { font-weight: 500; color: var(--text-2); }
.fld input, .fld select {
  width: 100%;
  padding: 9px 11px;
  border-radius: var(--r-md);
  border: 1px solid var(--border-strong);
  background: var(--bg-1);
  color: var(--text);
  font-family: inherit;
  font-size: 13.5px;
}
.fld input:focus, .fld select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}
.growth-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: var(--sp-4);
}
.growth-summary > div { display: flex; flex-direction: column; gap: 3px; }
.growth-summary span { font-size: 12px; color: var(--text-3); }
.growth-summary strong {
  font-family: "Space Grotesk", sans-serif;
  font-size: 1.35rem;
  font-variant-numeric: tabular-nums;
}
.growth-disclaimer { font-size: 12px; color: var(--text-3); margin: 8px 2px 0; }
.growth-link {
  display: flex; align-items: center; gap: 8px;
  background: var(--bg-1); border: 1px solid var(--border);
  border-radius: var(--r-md); padding: 8px 10px;
  font-size: 12px; color: var(--text-2); overflow-x: auto;
}
.growth-link code { white-space: nowrap; font-family: ui-monospace, Menlo, monospace; }
.growth-stats {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(90px, 1fr)); gap: 10px;
  border-top: 1px solid var(--border); padding-top: 10px;
}
.growth-stats > div { display: flex; flex-direction: column; gap: 2px; }
.growth-stats span { font-size: 11.5px; color: var(--text-3); }
.growth-stats strong { font-variant-numeric: tabular-nums; font-size: 15px; }
.growth-conf {
  font-size: 10.5px; letter-spacing: 0.03em;
  padding: 2px 7px; border-radius: 999px; font-weight: 600;
}
.growth-conf.estimated { background: var(--surface-2); color: var(--text-3); }
.growth-conf.measured { background: var(--accent-soft); color: var(--accent); }
.growth-roas {
  display: flex; align-items: baseline; gap: 14px; flex-wrap: wrap;
  border-top: 1px solid var(--border); padding-top: 10px;
}
.growth-roas > div:first-child { display: flex; flex-direction: column; gap: 2px; }
.growth-roas span { font-size: 11.5px; color: var(--text-3); }
.growth-roas strong { font-family: "Space Grotesk", sans-serif; font-size: 1.5rem; font-variant-numeric: tabular-nums; }
strong.pos { color: var(--ok); }
strong.neg { color: var(--crit); }
.growth-summary strong.pos, .growth-summary strong.neg { font-family: "Space Grotesk", sans-serif; }

.ag-tabs { display: flex; gap: 4px; }
.ag-tabs button {
  padding: 7px 14px; border: 1px solid var(--border); background: var(--surface);
  color: var(--text-2); border-radius: var(--r-md); font: inherit; font-size: 13px; cursor: pointer;
}
.ag-tabs button.active { background: var(--accent-soft); color: var(--accent); border-color: var(--accent); font-weight: 600; }
.ag-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.ag-table th, .ag-table td { text-align: left; padding: 10px 14px; border-bottom: 1px solid var(--border); white-space: nowrap; }
.ag-table th { font-size: 11.5px; letter-spacing: 0.02em; color: var(--text-3); font-weight: 600; }
.ag-table td { font-variant-numeric: tabular-nums; }
.ag-table tbody tr:last-child td { border-bottom: 0; }
.ag-table tbody tr:hover { background: var(--surface-2); }
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;;8EAI8E;;AAE9E;EACE,6CAA6C;EAC7C,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,0CAA0C;;EAE1C,wBAAwB;EACxB,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;;EAEzC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;;EAEvB,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,yCAAyC;EACzC,uCAAuC;;EAEvC,wDAAwD;EACxD,aAAa;EACb,mCAAmC;EACnC,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,sCAAsC;;EAEtC,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;;EAEZ,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;;EAEf,6CAA6C;EAC7C,yCAAyC;EACzC,kFAAkF;EAClF,sFAAsF;EACtF,iFAAiF;;EAEjF,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;;EAElB,oBAAoB;EACpB,sCAAsC;EACtC,yCAAyC;EACzC,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;;EAEjB,kBAAkB;EAClB,uFAAuF;EACvF,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;8EAE8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;EAChC,sCAAsC;;EAEtC,+BAA+B;EAC/B,uCAAuC;EACvC,wCAAwC;;EAExC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;;EAEvB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,sCAAsC;EACtC,yCAAyC;EACzC,uCAAuC;;EAEvC,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,qCAAqC;;EAErC,6CAA6C;EAC7C,yFAAyF;EACzF,4FAA4F;;EAE5F,mBAAmB;AACrB;;AAEA;EACE;;sFAEoF;AACtF;;AAEA,+EAA+E;AAC/E;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mFAAmF;AACrF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC;;wFAEsF;EACtF,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;;EAIE,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;8EAE8E;;AAE9E;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,2BAA2B;EAC3B,wEAAwE;AAC1E;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA,aAAa,uBAAuB,EAAE;AACtC,aAAa,uBAAuB,EAAE;AACtC,aAAa,uBAAuB,EAAE;AACtC,aAAa,uBAAuB,EAAE;AACtC;EACE,UAAU,UAAU,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC3D;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;;8EAE8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;;8EAE8E;;AAE9E;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB;0GACwG;AAC1G;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,8CAA8C;AAChD;AACA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;;8EAE8E;;AAE9E;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,mCAAmC;EACnC;wEACsE;AACxE;AACA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;8EAE8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;8EAE8E;;AAE9E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,mDAAmD;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;8EAE8E;;AAE9E;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,oCAAoC;EACpC,+BAA+B;EAC/B,kFAAkF;AACpF;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;;8EAE8E;;AAE9E;EACE,oBAAoB;EACpB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,qFAAqF;AACvF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,+HAA+H;AACjI;AACA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;8EAE8E;;AAE9E;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,OAAO;EACP,wEAAwE;EACxE,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,OAAO;EACP,wEAAwE;EACxE,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,QAAQ;EACR,wEAAwE;EACxE,YAAY;EACZ,oDAAoD;AACtD;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,yFAAyF;EACzF,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;8EAE8E;;AAE9E;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kFAAkF;AACpF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sCAAsC;EACtC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,sCAAsC;EACtC,uGAAuG;EACvG,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA,kCAAkC,4BAA4B,EAAE,kBAAkB,EAAE;AACpF,gCAAgC,4BAA4B,EAAE,kBAAkB,EAAE;AAClF,kCAAkC,0BAA0B,EAAE,gBAAgB,EAAE;AAChF;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,aAAa,oBAAoB,EAAE,cAAc,EAAE,6CAA6C,EAAE;AAClG,4BAA4B,oBAAoB,EAAE;AAClD;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,uBAAuB;EACvB,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;;EAEE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,4BAA4B,oBAAoB,EAAE;AAClD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,sCAAsC;EACtC;;kBAEgB;EAChB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;8EAE8E;;AAE9E;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B;;;eAGa;AACf;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,qHAAqH;AACvH;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;8EAE8E;;AAE9E;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,qCAAqC;EACrC,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qFAAqF;AACvF;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;EACtC,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,uCAAuC;EACvC,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;8EAE8E;;AAE9E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,uFAAuF;EACvF,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;8EAE8E;;AAE9E;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;AACA;EACE;IACE,6CAA6C;EAC/C;AACF;AACA;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;;;IAGE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;EACzC;AACF;;AAEA;;8EAE8E;;AAE9E;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,4BAA4B;IAC5B,4CAA4C;IAC5C,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;8EAE8E;;AAE9E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA,gBAAgB,oBAAoB,EAAE;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,iFAAiF;AACnF;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA,eAAe,gBAAgB,EAAE;AACjC,iBAAiB,kBAAkB,EAAE;AACrC,iBAAiB,oBAAoB,EAAE;AACvC;EACE,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,aAAa;EACb,sCAAsC;EACtC,uCAAuC;EACvC,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE;IACE,4DAA4D;EAC9D;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;;AAEA;;8EAE8E;;AAE9E;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;AACA,gCAAgC,oBAAoB,EAAE;AACtD;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB,iBAAiB,EAAE;AACtC;;AAEA;;8EAE8E;;AAE9E,yBAAyB;AACzB,cAAc,kBAAkB,EAAE;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA,wBAAwB,kCAAkC,EAAE;AAC5D,oBAAoB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpF;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,yBAAyB,4BAA4B,EAAE,kBAAkB,EAAE;AAC3E,0BAA0B,kBAAkB,EAAE,8BAA8B,EAAE;AAC9E,qCAAqC,OAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC9G;EACE,aAAa;EACb,QAAQ;EACR,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;AACA,gCAAgC,4BAA4B,EAAE,kBAAkB,EAAE;;AAElF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,gBAAgB,4BAA4B,EAAE,kBAAkB,EAAE;AAClE;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,mBAAmB,4BAA4B,EAAE,kBAAkB,EAAE;AACrE,mBAAmB,4BAA4B,EAAE,kBAAkB,EAAE;;AAErE,wBAAwB;AACxB,cAAc,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AACvE,WAAW,UAAU,EAAE,gBAAgB,EAAE;AACzC,wBAAwB,YAAY,EAAE;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;AACA,kBAAkB,oBAAoB,EAAE,kCAAkC,EAAE;;AAE5E,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA,2CAA2C,4BAA4B,EAAE;AACzE,+BAA+B,YAAY,EAAE,mBAAmB,EAAE;AAClE;EACE,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC,OAAO,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACzE,cAAc,gBAAgB,EAAE,oBAAoB,EAAE;AACtD;EACE,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAgB;AAClB;AACA,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzE,uBAAuB,eAAe,EAAE,oBAAoB,EAAE;AAC9D;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;AACpC;AACA,qBAAqB,eAAe,EAAE,oBAAoB,EAAE,iBAAiB,EAAE;AAC/E;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,uBAAuB,EAAE,+BAA+B;EACxD,0BAA0B,EAAE,iBAAiB;EAC7C,eAAe,EAAE,oBAAoB,EAAE,gBAAgB;AACzD;AACA,oBAAoB,mBAAmB,EAAE,2CAA2C,EAAE;AACtF;EACE,aAAa,EAAE,0DAA0D,EAAE,SAAS;EACpF,mCAAmC,EAAE,iBAAiB;AACxD;AACA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACvE,qBAAqB,iBAAiB,EAAE,oBAAoB,EAAE;AAC9D,uBAAuB,kCAAkC,EAAE,eAAe,EAAE;AAC5E;EACE,iBAAiB,EAAE,sBAAsB;EACzC,gBAAgB,EAAE,oBAAoB,EAAE,gBAAgB;AAC1D;AACA,yBAAyB,4BAA4B,EAAE,oBAAoB,EAAE;AAC7E,wBAAwB,8BAA8B,EAAE,oBAAoB,EAAE;AAC9E;EACE,aAAa,EAAE,qBAAqB,EAAE,SAAS,EAAE,eAAe;EAChE,mCAAmC,EAAE,iBAAiB;AACxD;AACA,iCAAiC,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClF,oBAAoB,iBAAiB,EAAE,oBAAoB,EAAE;AAC7D,sBAAsB,wCAAwC,EAAE,iBAAiB,EAAE,kCAAkC,EAAE;AACvH,aAAa,gBAAgB,EAAE;AAC/B,aAAa,kBAAkB,EAAE;AACjC,yDAAyD,wCAAwC,EAAE;;AAEnG,WAAW,aAAa,EAAE,QAAQ,EAAE;AACpC;EACE,iBAAiB,EAAE,+BAA+B,EAAE,0BAA0B;EAC9E,oBAAoB,EAAE,0BAA0B,EAAE,aAAa,EAAE,eAAe,EAAE,eAAe;AACnG;AACA,yBAAyB,8BAA8B,EAAE,oBAAoB,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AAC9H,YAAY,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACrE,6BAA6B,gBAAgB,EAAE,kBAAkB,EAAE,sCAAsC,EAAE,mBAAmB,EAAE;AAChI,eAAe,iBAAiB,EAAE,sBAAsB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAClG,eAAe,kCAAkC,EAAE;AACnD,mCAAmC,gBAAgB,EAAE;AACrD,2BAA2B,4BAA4B,EAAE","sourcesContent":["/* =========================================================================\n   Vokelle — Tasarım Sistemi\n   Tek vurgu rengi (amber), near-black nötr zemin, tutarlı spacing/radius/shadow.\n   Display: Space Grotesk · Body: Inter\n   ========================================================================= */\n\n:root {\n  /* --- Nötr zemin (near-black charcoal) --- */\n  --bg: #0a0a0b;\n  --bg-1: #0e0e10;\n  --surface: #141417;\n  --surface-2: #1a1a1e;\n  --surface-3: #212127;\n  --glass: rgba(255, 255, 255, 0.028);\n  --glass-strong: rgba(255, 255, 255, 0.045);\n\n  /* --- Kenarlıklar --- */\n  --border: rgba(255, 255, 255, 0.07);\n  --border-strong: rgba(255, 255, 255, 0.12);\n  --border-accent: rgba(255, 178, 36, 0.35);\n\n  /* --- Metin --- */\n  --text: #ededef;\n  --text-2: #b4b4bd;\n  --text-3: #82828c;\n  --text-inverse: #16130c;\n\n  /* --- Tek vurgu rengi: Amber --- */\n  --accent: #ffb224;\n  --accent-hover: #ffc457;\n  --accent-press: #f0a412;\n  --accent-soft: rgba(255, 178, 36, 0.12);\n  --accent-soft-2: rgba(255, 178, 36, 0.18);\n  --accent-glow: rgba(255, 178, 36, 0.28);\n\n  /* --- Semantik (severity) — vurgudan ayrık tonlar --- */\n  --ok: #3dd68c;\n  --ok-soft: rgba(61, 214, 140, 0.14);\n  --warn: #ffb224;\n  --warn-soft: rgba(255, 178, 36, 0.14);\n  --crit: #ff5c5c;\n  --crit-soft: rgba(255, 92, 92, 0.14);\n  --info: #6aa8ff;\n  --info-soft: rgba(106, 168, 255, 0.14);\n\n  /* --- Spacing ölçeği --- */\n  --sp-1: 4px;\n  --sp-2: 8px;\n  --sp-3: 12px;\n  --sp-4: 16px;\n  --sp-5: 24px;\n  --sp-6: 32px;\n  --sp-7: 48px;\n  --sp-8: 64px;\n  --sp-9: 96px;\n\n  /* --- Radius ölçeği --- */\n  --r-sm: 8px;\n  --r-md: 12px;\n  --r-lg: 16px;\n  --r-xl: 22px;\n  --r-full: 999px;\n\n  /* --- Gölge ölçeği (yumuşak, katmanlı) --- */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 16px -4px rgba(0, 0, 0, 0.4), 0 2px 6px -2px rgba(0, 0, 0, 0.3);\n  --shadow-lg: 0 16px 48px -12px rgba(0, 0, 0, 0.55), 0 6px 16px -6px rgba(0, 0, 0, 0.4);\n  --shadow-glow: 0 0 0 1px var(--border-accent), 0 8px 40px -8px var(--accent-glow);\n\n  /* --- Layout --- */\n  --maxw: 1120px;\n  --nav-h: 68px;\n  --sidebar-w: 244px;\n\n  /* --- Hareket --- */\n  --ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);\n  --dur-fast: 0.14s;\n  --dur: 0.24s;\n  --dur-slow: 0.45s;\n\n  color-scheme: dark;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-feature-settings: \"cv05\", \"cv08\", \"ss01\";\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n\n/* =========================================================================\n   AÇIK TEMA — data-theme=\"light\"\n   ========================================================================= */\n:root[data-theme=\"light\"] {\n  --bg: #f6f6f4;\n  --bg-1: #ffffff;\n  --surface: #ffffff;\n  --surface-2: #f3f3f1;\n  --surface-3: #e9e9e6;\n  --glass: rgba(20, 20, 24, 0.022);\n  --glass-strong: rgba(20, 20, 24, 0.04);\n\n  --border: rgba(20, 20, 24, 0.1);\n  --border-strong: rgba(20, 20, 24, 0.18);\n  --border-accent: rgba(217, 130, 10, 0.4);\n\n  --text: #1b1b1f;\n  --text-2: #4c4c55;\n  --text-3: #78787f;\n  --text-inverse: #ffffff;\n\n  --accent: #d9820a;\n  --accent-hover: #c47408;\n  --accent-press: #a86107;\n  --accent-soft: rgba(217, 130, 10, 0.1);\n  --accent-soft-2: rgba(217, 130, 10, 0.16);\n  --accent-glow: rgba(217, 130, 10, 0.22);\n\n  --ok: #17924f;\n  --ok-soft: rgba(23, 146, 79, 0.12);\n  --warn: #b26a00;\n  --warn-soft: rgba(178, 106, 0, 0.13);\n  --crit: #d13b3b;\n  --crit-soft: rgba(209, 59, 59, 0.11);\n  --info: #2f6fd0;\n  --info-soft: rgba(47, 111, 208, 0.12);\n\n  --shadow-sm: 0 1px 2px rgba(20, 20, 24, 0.06);\n  --shadow-md: 0 4px 16px -4px rgba(20, 20, 24, 0.1), 0 2px 6px -2px rgba(20, 20, 24, 0.06);\n  --shadow-lg: 0 16px 48px -12px rgba(20, 20, 24, 0.16), 0 6px 16px -6px rgba(20, 20, 24, 0.1);\n\n  color-scheme: light;\n}\n\n:root[data-theme=\"light\"] body {\n  background-image:\n    radial-gradient(900px 500px at 15% -8%, rgba(217, 130, 10, 0.07), transparent 60%),\n    radial-gradient(700px 600px at 100% 0%, rgba(47, 111, 208, 0.05), transparent 55%);\n}\n\n/* Hero mesh koyu için tasarlandı; açık temada çarpım harmanı + düşük opaklık */\n:root[data-theme=\"light\"] .hero-mesh {\n  opacity: 0.3;\n}\n:root[data-theme=\"light\"] .hero-mesh span {\n  mix-blend-mode: multiply;\n}\n:root[data-theme=\"light\"] .nav.scrolled {\n  background: rgba(255, 255, 255, 0.8);\n}\n:root[data-theme=\"light\"] .app-topbar {\n  background: rgba(255, 255, 255, 0.75);\n}\n:root[data-theme=\"light\"] .avatar {\n  background: var(--accent-soft-2);\n}\n:root[data-theme=\"light\"] .hero-visual {\n  background: linear-gradient(180deg, rgba(20, 20, 24, 0.03), rgba(20, 20, 24, 0.01));\n}\n:root[data-theme=\"light\"] .sidebar {\n  background: var(--surface-2);\n}\n:root[data-theme=\"light\"] .site-footer {\n  background: var(--bg-1);\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\nbody {\n  background: var(--bg);\n  color: var(--text);\n  line-height: 1.6;\n  font-size: 15px;\n  /* Zemin üzerinde çok hafif atmosfer */\n  background-image:\n    radial-gradient(900px 500px at 15% -8%, rgba(255, 178, 36, 0.05), transparent 60%),\n    radial-gradient(700px 600px at 100% 0%, rgba(106, 168, 255, 0.035), transparent 55%);\n  background-attachment: fixed;\n}\n\n::selection {\n  background: var(--accent-soft-2);\n  color: var(--text);\n}\n\nh1,\nh2,\nh3,\nh4 {\n  font-family: \"Space Grotesk\", \"Inter\", sans-serif;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.12;\n  color: var(--text);\n}\n\na {\n  color: var(--text);\n  text-decoration: none;\n  transition: color var(--dur-fast) var(--ease);\n}\na:hover {\n  color: var(--accent);\n}\n\np {\n  color: var(--text-2);\n}\n\n:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* =========================================================================\n   Layout yardımcıları\n   ========================================================================= */\n\n.container {\n  max-width: var(--maxw);\n  margin: 0 auto;\n  padding: 0 var(--sp-5);\n}\n\n.page-enter {\n  animation: fadeInUp var(--dur-slow) var(--ease-out) both;\n}\n\n/* Scroll-reveal */\n.reveal {\n  opacity: 0;\n  transform: translateY(18px);\n  transition: opacity 0.6s var(--ease-out), transform 0.6s var(--ease-out);\n}\n.reveal.revealed {\n  opacity: 1;\n  transform: none;\n}\n.reveal.d1 { transition-delay: 0.06s; }\n.reveal.d2 { transition-delay: 0.12s; }\n.reveal.d3 { transition-delay: 0.18s; }\n.reveal.d4 { transition-delay: 0.24s; }\n@media (prefers-reduced-motion: reduce) {\n  .reveal { opacity: 1; transform: none; transition: none; }\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n}\n\n.eyebrow {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--accent);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-2);\n}\n.eyebrow::before {\n  content: \"\";\n  width: 18px;\n  height: 1px;\n  background: var(--accent);\n  opacity: 0.6;\n}\n\n/* =========================================================================\n   Marka\n   ========================================================================= */\n\n.brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  font-family: \"Space Grotesk\", sans-serif;\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: -0.02em;\n  color: var(--text);\n}\n.brand:hover {\n  color: var(--text);\n}\n.brand svg {\n  flex-shrink: 0;\n}\n\n/* =========================================================================\n   Butonlar\n   ========================================================================= */\n\n.btn {\n  --btn-bg: var(--accent);\n  --btn-fg: var(--text-inverse);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--sp-2);\n  padding: 10px 18px;\n  border-radius: var(--r-md);\n  border: 1px solid transparent;\n  background: var(--btn-bg);\n  color: var(--btn-fg);\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: transform var(--dur-fast) var(--ease), background var(--dur) var(--ease),\n    box-shadow var(--dur) var(--ease), border-color var(--dur) var(--ease), opacity var(--dur) var(--ease);\n}\n.btn:hover {\n  background: var(--accent-hover);\n  color: var(--text-inverse);\n  box-shadow: 0 6px 24px -8px var(--accent-glow);\n}\n.btn:active {\n  transform: translateY(1px) scale(0.985);\n  background: var(--accent-press);\n}\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.btn-ghost {\n  --btn-bg: transparent;\n  --btn-fg: var(--text);\n  border-color: var(--border-strong);\n}\n.btn-ghost:hover {\n  --btn-bg: var(--glass-strong);\n  color: var(--text);\n  border-color: var(--border-strong);\n  box-shadow: none;\n}\n.btn-ghost:active {\n  background: var(--surface-2);\n}\n\n.btn-subtle {\n  --btn-bg: var(--surface-2);\n  --btn-fg: var(--text);\n  border-color: var(--border);\n}\n.btn-subtle:hover {\n  --btn-bg: var(--surface-3);\n  color: var(--text);\n  box-shadow: none;\n}\n\n.btn-sm {\n  padding: 7px 13px;\n  font-size: 13px;\n  border-radius: var(--r-sm);\n}\n.btn-lg {\n  padding: 13px 24px;\n  font-size: 15px;\n}\n.btn-block {\n  width: 100%;\n}\n\n/* =========================================================================\n   Kartlar / yüzeyler (glass)\n   ========================================================================= */\n\n.card {\n  background: var(--glass);\n  border: 1px solid var(--border);\n  border-radius: var(--r-lg);\n  padding: var(--sp-5);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  transition: transform var(--dur) var(--ease), border-color var(--dur) var(--ease),\n    box-shadow var(--dur) var(--ease), background var(--dur) var(--ease);\n}\n.card-hover:hover {\n  transform: translateY(-3px);\n  border-color: var(--border-strong);\n  box-shadow: var(--shadow-lg);\n  background: var(--glass-strong);\n}\n\n.panel {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--r-lg);\n  box-shadow: var(--shadow-md);\n}\n\n/* =========================================================================\n   Rozetler / chip'ler\n   ========================================================================= */\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: var(--r-full);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  border: 1px solid var(--border);\n  color: var(--text-2);\n  background: var(--glass);\n}\n.badge.ok {\n  color: var(--ok);\n  background: var(--ok-soft);\n  border-color: transparent;\n}\n.badge.warn {\n  color: var(--warn);\n  background: var(--warn-soft);\n  border-color: transparent;\n}\n.badge.crit {\n  color: var(--crit);\n  background: var(--crit-soft);\n  border-color: transparent;\n}\n.badge.info {\n  color: var(--info);\n  background: var(--info-soft);\n  border-color: transparent;\n}\n\n/* =========================================================================\n   Nabız / durum göstergesi\n   ========================================================================= */\n\n.pulse {\n  position: relative;\n  display: inline-flex;\n  width: 9px;\n  height: 9px;\n  flex-shrink: 0;\n}\n.pulse::before,\n.pulse::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n}\n.pulse::before {\n  background: var(--dot, var(--text-3));\n  box-shadow: 0 0 8px var(--dot, transparent);\n}\n.pulse::after {\n  background: var(--dot, var(--text-3));\n  animation: pulse-ring 2.4s var(--ease-out) infinite;\n}\n.pulse.is-static::after {\n  display: none;\n}\n.pulse.ok {\n  --dot: var(--ok);\n}\n.pulse.warn {\n  --dot: var(--warn);\n}\n.pulse.crit {\n  --dot: var(--crit);\n}\n.pulse.idle {\n  --dot: var(--text-3);\n}\n\n.status-line {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-2);\n  font-size: 13px;\n  color: var(--text-2);\n}\n\n/* =========================================================================\n   Marketing navigasyonu\n   ========================================================================= */\n\n.nav {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  height: var(--nav-h);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--sp-5);\n  border-bottom: 1px solid transparent;\n  background: rgba(10, 10, 11, 0);\n  transition: background var(--dur) var(--ease), border-color var(--dur) var(--ease);\n}\n.nav.scrolled {\n  background: rgba(10, 10, 11, 0.72);\n  border-bottom-color: var(--border);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n}\n.nav .container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-5);\n}\n.nav-links .link {\n  font-size: 14px;\n  color: var(--text-2);\n  font-weight: 450;\n}\n.nav-links .link:hover {\n  color: var(--text);\n}\n\n/* =========================================================================\n   Dil değiştirici\n   ========================================================================= */\n\n.lang-toggle {\n  display: inline-flex;\n  padding: 3px;\n  border: 1px solid var(--border);\n  border-radius: var(--r-full);\n  background: var(--glass);\n  gap: 2px;\n}\n.lang-toggle button {\n  background: transparent;\n  color: var(--text-3);\n  border: 0;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  border-radius: var(--r-full);\n  transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);\n}\n.lang-toggle button:hover {\n  color: var(--text-2);\n}\n.lang-toggle button.active {\n  background: var(--accent);\n  color: var(--text-inverse);\n}\n\n/* Tema değiştirici */\n.theme-toggle {\n  display: inline-grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--border);\n  border-radius: var(--r-full);\n  background: var(--glass);\n  color: var(--text-2);\n  cursor: pointer;\n  transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease), border-color var(--dur-fast) var(--ease);\n}\n.theme-toggle:hover {\n  color: var(--accent);\n  border-color: var(--border-accent);\n}\n\n/* =========================================================================\n   Hero\n   ========================================================================= */\n\n.hero {\n  position: relative;\n  padding: var(--sp-9) 0 var(--sp-8);\n  overflow: hidden;\n}\n.hero-grid {\n  position: relative;\n  z-index: 2;\n  display: grid;\n  grid-template-columns: 1.05fr 0.95fr;\n  gap: var(--sp-7);\n  align-items: center;\n}\n.hero h1 {\n  font-size: clamp(2.4rem, 5vw, 3.5rem);\n  margin: var(--sp-4) 0 var(--sp-4);\n}\n.hero .lede {\n  font-size: 1.075rem;\n  color: var(--text-2);\n  max-width: 30rem;\n  margin-bottom: var(--sp-5);\n}\n.hero-actions {\n  display: flex;\n  gap: var(--sp-3);\n  flex-wrap: wrap;\n}\n.hero-trust {\n  margin-top: var(--sp-6);\n  display: flex;\n  align-items: center;\n  gap: var(--sp-4);\n  color: var(--text-3);\n  font-size: 13px;\n}\n.hero-trust .dot-sep {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: var(--text-3);\n}\n\n/* Hero arkaplan blob mesh */\n.hero-mesh {\n  position: absolute;\n  inset: -20% -10% auto -10%;\n  height: 640px;\n  z-index: 1;\n  pointer-events: none;\n  filter: blur(90px);\n  opacity: 0.55;\n}\n.hero-mesh span {\n  position: absolute;\n  border-radius: 50%;\n  mix-blend-mode: screen;\n}\n.hero-mesh .b1 {\n  width: 420px;\n  height: 420px;\n  left: 4%;\n  top: 8%;\n  background: radial-gradient(circle at 30% 30%, #ffb224, transparent 70%);\n  animation: drift1 16s ease-in-out infinite alternate;\n}\n.hero-mesh .b2 {\n  width: 380px;\n  height: 380px;\n  right: 10%;\n  top: 0%;\n  background: radial-gradient(circle at 60% 40%, #6aa8ff, transparent 70%);\n  animation: drift2 20s ease-in-out infinite alternate;\n}\n.hero-mesh .b3 {\n  width: 320px;\n  height: 320px;\n  right: 26%;\n  top: 40%;\n  background: radial-gradient(circle at 50% 50%, #ff7d5c, transparent 72%);\n  opacity: 0.7;\n  animation: drift3 24s ease-in-out infinite alternate;\n}\n\n/* Hero görsel kartı (sinyal / nabız) */\n.hero-visual {\n  position: relative;\n  border: 1px solid var(--border);\n  border-radius: var(--r-xl);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  box-shadow: var(--shadow-lg);\n  padding: var(--sp-5);\n  overflow: hidden;\n}\n.hero-visual .hv-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--sp-4);\n}\n.hero-visual .hv-title {\n  font-size: 13px;\n  color: var(--text-3);\n  font-weight: 500;\n}\n.hero-visual svg {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n/* =========================================================================\n   Bölümler\n   ========================================================================= */\n\n.section {\n  padding: var(--sp-9) 0;\n}\n.section-head {\n  max-width: 40rem;\n  margin: 0 auto var(--sp-7);\n  text-align: center;\n}\n.section-head h2 {\n  font-size: clamp(1.7rem, 3vw, 2.2rem);\n  margin: var(--sp-3) 0 var(--sp-3);\n}\n.section-head p {\n  color: var(--text-2);\n}\n\n.divider {\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--border-strong), transparent);\n}\n\n/* Özellik ızgarası */\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(248px, 1fr));\n  gap: var(--sp-4);\n}\n.feature {\n  padding: var(--sp-5);\n}\n.feature .ico {\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--r-md);\n  background: var(--accent-soft);\n  color: var(--accent);\n  margin-bottom: var(--sp-4);\n}\n.feature h3 {\n  font-size: 1.05rem;\n  margin-bottom: var(--sp-2);\n}\n.feature p {\n  font-size: 0.925rem;\n  color: var(--text-2);\n}\n\n/* Nasıl çalışır */\n.steps {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--sp-4);\n  counter-reset: step;\n}\n.step {\n  position: relative;\n  padding: var(--sp-5);\n}\n.step .num {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--accent);\n  display: inline-grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--r-full);\n  border: 1px solid var(--border-accent);\n  background: var(--accent-soft);\n  margin-bottom: var(--sp-3);\n}\n.step p {\n  font-size: 0.95rem;\n}\n\n/* Fiyatlandırma */\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--sp-4);\n}\n.price-card {\n  text-align: center;\n  padding: var(--sp-6) var(--sp-5);\n  position: relative;\n}\n.price-card.featured {\n  border-color: var(--border-accent);\n  box-shadow: var(--shadow-glow);\n}\n.price-card .tag {\n  position: absolute;\n  top: -11px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-inverse);\n  background: var(--accent);\n  padding: 3px 10px;\n  border-radius: var(--r-full);\n}\n.price-card .plan-name {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: var(--sp-2);\n}\n.price-card .plan-hint {\n  font-size: 0.85rem;\n  color: var(--text-3);\n  margin-bottom: var(--sp-4);\n}\n.pricing-note {\n  text-align: center;\n  color: var(--text-3);\n  font-size: 0.9rem;\n  margin-top: var(--sp-6);\n  max-width: 34rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Problem / çözüm */\n.pain-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--sp-4);\n  margin-bottom: var(--sp-6);\n}\n.pain-card {\n  padding: var(--sp-6);\n  border-color: rgba(255, 92, 92, 0.18);\n}\n.pain-card .pain-ico {\n  width: 42px;\n  height: 42px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--r-md);\n  background: var(--crit-soft);\n  color: var(--crit);\n  margin-bottom: var(--sp-4);\n}\n.solution-band {\n  padding: var(--sp-6);\n  border-radius: var(--r-xl);\n  border: 1px solid var(--border-accent);\n  background: radial-gradient(600px 200px at 50% 0%, var(--accent-soft), transparent 70%), var(--surface);\n  text-align: center;\n}\n.solution-band h3 {\n  font-size: 1.3rem;\n  margin-bottom: var(--sp-3);\n}\n\n/* Neyi yakalar — metrik detay */\n.detect-list {\n  display: grid;\n  gap: var(--sp-4);\n}\n.detect-row {\n  display: grid;\n  grid-template-columns: 48px 1fr;\n  gap: var(--sp-4);\n  padding: var(--sp-5);\n  align-items: start;\n}\n.detect-row .d-ico {\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--r-md);\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n.detect-row .d-ico.tone-players { background: var(--info-soft); color: var(--info); }\n.detect-row .d-ico.tone-cheat { background: var(--crit-soft); color: var(--crit); }\n.detect-row .d-ico.tone-content { background: var(--ok-soft); color: var(--ok); }\n.detect-row h3 {\n  font-size: 1.05rem;\n  margin-bottom: 4px;\n}\n.detect-row p {\n  font-size: 0.93rem;\n  margin-bottom: 0;\n}\n\n/* FAQ */\n.faq {\n  max-width: 44rem;\n  margin: 0 auto;\n}\n.faq-item {\n  border-bottom: 1px solid var(--border);\n}\n.faq-q {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--sp-4);\n  padding: var(--sp-4) 0;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--text);\n  text-align: left;\n}\n.faq-q svg { color: var(--text-3); flex-shrink: 0; transition: color var(--dur-fast) var(--ease); }\n.faq-item.open .faq-q svg { color: var(--accent); }\n.faq-a {\n  overflow: hidden;\n  transition: max-height var(--dur) var(--ease);\n}\n.faq-a p {\n  padding: 0 0 var(--sp-4);\n  color: var(--text-2);\n  font-size: 0.94rem;\n  line-height: 1.65;\n  margin: 0;\n}\n\n/* Kurumsal footer */\n.corp-footer {\n  border-top: 1px solid var(--border);\n  background: var(--bg-1);\n  padding: var(--sp-8) 0 var(--sp-6);\n  margin-top: var(--sp-9);\n}\n.corp-footer .cols {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr 1fr 1fr;\n  gap: var(--sp-6);\n  margin-bottom: var(--sp-7);\n}\n.corp-footer .col h4 {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-3);\n  margin-bottom: var(--sp-4);\n}\n.corp-footer .col a,\n.corp-footer .col p {\n  display: block;\n  color: var(--text-2);\n  font-size: 13.5px;\n  margin-bottom: 10px;\n}\n.corp-footer .col a:hover { color: var(--accent); }\n.corp-footer .brand-col p {\n  color: var(--text-3);\n  max-width: 22rem;\n  margin-top: var(--sp-3);\n}\n.corp-footer .bottom {\n  border-top: 1px solid var(--border);\n  padding-top: var(--sp-5);\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--sp-3);\n  color: var(--text-3);\n  font-size: 12.5px;\n}\n\n/* CTA şeridi */\n.cta-band {\n  text-align: center;\n  padding: var(--sp-8) var(--sp-6);\n  border-radius: var(--r-xl);\n  border: 1px solid var(--border-accent);\n  background:\n    radial-gradient(600px 200px at 50% 0%, var(--accent-soft), transparent 70%),\n    var(--surface);\n  box-shadow: var(--shadow-md);\n}\n.cta-band h2 {\n  font-size: clamp(1.6rem, 3vw, 2rem);\n  margin-bottom: var(--sp-3);\n}\n.cta-band p {\n  margin-bottom: var(--sp-5);\n}\n\n/* Footer */\n.site-footer {\n  border-top: 1px solid var(--border);\n  padding: var(--sp-6) 0;\n  margin-top: var(--sp-8);\n}\n.site-footer .container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--sp-3);\n  color: var(--text-3);\n  font-size: 13px;\n}\n\n/* =========================================================================\n   Auth ekranları\n   ========================================================================= */\n\n.auth-screen {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n.auth-aside {\n  position: relative;\n  padding: var(--sp-8) var(--sp-7);\n  border-right: 1px solid var(--border);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background:\n    radial-gradient(700px 400px at 20% 10%, rgba(255, 178, 36, 0.08), transparent 60%),\n    radial-gradient(600px 500px at 90% 90%, rgba(106, 168, 255, 0.06), transparent 60%),\n    var(--bg-1);\n}\n.auth-aside .aside-body {\n  margin-top: auto;\n  max-width: 26rem;\n}\n.auth-aside h2 {\n  font-size: 1.9rem;\n  margin: var(--sp-4) 0 var(--sp-3);\n}\n.auth-aside p {\n  color: var(--text-2);\n}\n.auth-aside .aside-visual {\n  position: absolute;\n  right: -60px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 420px;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.auth-main {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--sp-7) var(--sp-5);\n}\n.auth-card {\n  width: 100%;\n  max-width: 384px;\n}\n.auth-card .auth-head {\n  margin-bottom: var(--sp-5);\n}\n.auth-card h1 {\n  font-size: 1.5rem;\n  margin-bottom: var(--sp-2);\n}\n.auth-card .sub {\n  color: var(--text-3);\n  font-size: 0.9rem;\n}\n\n.field {\n  margin-bottom: var(--sp-4);\n}\n.field label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-2);\n  margin-bottom: 6px;\n}\n.field .control {\n  position: relative;\n}\n.field input {\n  width: 100%;\n  padding: 11px 13px;\n  border-radius: var(--r-md);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-1);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 14px;\n  transition: border-color var(--dur) var(--ease), box-shadow var(--dur) var(--ease), background var(--dur) var(--ease);\n}\n.field input::placeholder {\n  color: var(--text-3);\n}\n.field input:hover {\n  border-color: var(--border-strong);\n}\n.field input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n  background: var(--surface);\n}\n.field .hint {\n  font-size: 12px;\n  color: var(--text-3);\n  margin-top: 5px;\n}\n\n.form-error {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-2);\n  background: var(--crit-soft);\n  border: 1px solid rgba(255, 92, 92, 0.3);\n  color: #ffb3b3;\n  padding: 10px 12px;\n  border-radius: var(--r-md);\n  font-size: 13px;\n  margin-bottom: var(--sp-4);\n  animation: fadeInUp var(--dur) var(--ease-out) both;\n}\n\n.auth-alt {\n  margin-top: var(--sp-5);\n  padding-top: var(--sp-4);\n  border-top: 1px solid var(--border);\n  font-size: 13px;\n  color: var(--text-3);\n  text-align: center;\n}\n.auth-alt a {\n  color: var(--accent);\n  font-weight: 500;\n}\n\n.auth-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--sp-7);\n}\n\n/* =========================================================================\n   Uygulama kabuğu (dashboard / admin)\n   ========================================================================= */\n\n.app-shell {\n  display: grid;\n  grid-template-columns: var(--sidebar-w) 1fr;\n  min-height: 100vh;\n}\n\n.sidebar {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  border-right: 1px solid var(--border);\n  background: var(--bg-1);\n  padding: var(--sp-5) var(--sp-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-2);\n}\n.sidebar .brand {\n  padding: 0 var(--sp-3) var(--sp-5);\n}\n.sidebar .nav-group-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-3);\n  padding: var(--sp-3) var(--sp-3) var(--sp-2);\n}\n.sidebar nav {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.side-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px var(--sp-3);\n  border-radius: var(--r-sm);\n  color: var(--text-3);\n  font-size: 13.5px;\n  font-weight: 450;\n  position: relative;\n  transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);\n}\n.side-link svg {\n  width: 16px;\n  height: 16px;\n  opacity: 0.8;\n}\n.side-link:hover {\n  color: var(--text);\n  background: var(--glass);\n}\n.side-link.active {\n  color: var(--text);\n  background: var(--glass-strong);\n}\n.side-link.active::before {\n  content: \"\";\n  position: absolute;\n  left: calc(-1 * var(--sp-3));\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 18px;\n  border-radius: var(--r-full);\n  background: var(--accent);\n}\n.sidebar .side-foot {\n  margin-top: auto;\n  padding: var(--sp-3);\n  border-top: 1px solid var(--border);\n}\n\n.app-main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.app-topbar {\n  height: var(--nav-h);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--sp-6);\n  border-bottom: 1px solid var(--border);\n  background: rgba(10, 10, 11, 0.7);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n.app-topbar .crumb {\n  font-size: 13px;\n  color: var(--text-3);\n}\n.app-topbar .crumb strong {\n  color: var(--text);\n  font-weight: 600;\n}\n.topbar-right {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n}\n.avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: var(--r-full);\n  display: grid;\n  place-items: center;\n  background: var(--accent-soft);\n  color: var(--accent);\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid var(--border-accent);\n}\n\n@media (max-width: 560px) {\n  .logout-label {\n    display: none;\n  }\n}\n\n.app-body {\n  padding: var(--sp-6);\n  max-width: 1160px;\n  width: 100%;\n}\n.app-body > .page-title {\n  font-size: 1.6rem;\n  margin-bottom: 4px;\n}\n.app-body > .page-sub {\n  color: var(--text-3);\n  font-size: 0.92rem;\n  margin-bottom: var(--sp-6);\n}\n\n/* İstatistik kartları */\n.stat-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: var(--sp-4);\n  margin-bottom: var(--sp-5);\n}\n.stat {\n  padding: var(--sp-5);\n}\n.stat .stat-label {\n  font-size: 12px;\n  color: var(--text-3);\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: var(--sp-3);\n}\n.stat .stat-value {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 2rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n.stat .stat-meta {\n  margin-top: var(--sp-3);\n  font-size: 12px;\n  color: var(--text-3);\n}\n.stat .stat-meta .up {\n  color: var(--ok);\n}\n.stat .stat-meta .down {\n  color: var(--crit);\n}\n\n/* Grafik kartı */\n.chart-card {\n  padding: var(--sp-5);\n  margin-bottom: var(--sp-4);\n}\n.chart-card .chart-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--sp-4);\n}\n.chart-card .chart-head h3 {\n  font-size: 1rem;\n}\n.chart-canvas {\n  width: 100%;\n}\n\n/* Boş durum */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: var(--sp-8) var(--sp-6);\n  border: 1px dashed var(--border-strong);\n  border-radius: var(--r-lg);\n  background: var(--glass);\n}\n.empty-state svg {\n  margin-bottom: var(--sp-4);\n}\n.empty-state h3 {\n  font-size: 1.05rem;\n  margin-bottom: var(--sp-2);\n}\n.empty-state p {\n  color: var(--text-3);\n  font-size: 0.92rem;\n  max-width: 26rem;\n}\n\n/* Liste (alarmlar vb.) */\n.list {\n  display: flex;\n  flex-direction: column;\n}\n.list-row {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n  padding: var(--sp-3) var(--sp-4);\n  border-bottom: 1px solid var(--border);\n  font-size: 13.5px;\n}\n.list-row:last-child {\n  border-bottom: 0;\n}\n.list-row .row-main {\n  flex: 1;\n  min-width: 0;\n}\n.list-row .row-time {\n  color: var(--text-3);\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* =========================================================================\n   Skeleton yükleme\n   ========================================================================= */\n\n.skeleton {\n  position: relative;\n  overflow: hidden;\n  background: var(--surface-2);\n  border-radius: var(--r-sm);\n}\n.skeleton::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.06), transparent);\n  animation: shimmer 1.6s infinite;\n}\n.sk-text {\n  height: 12px;\n  margin: 6px 0;\n}\n.sk-title {\n  height: 20px;\n  width: 40%;\n  margin-bottom: 12px;\n}\n.sk-value {\n  height: 32px;\n  width: 55%;\n}\n.sk-block {\n  height: 180px;\n  border-radius: var(--r-md);\n}\n\n/* =========================================================================\n   Keyframes\n   ========================================================================= */\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes pulse-ring {\n  0% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  70% {\n    transform: scale(2.6);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(2.6);\n    opacity: 0;\n  }\n}\n\n@keyframes drift1 {\n  to {\n    transform: translate(40px, 30px) scale(1.1);\n  }\n}\n@keyframes drift2 {\n  to {\n    transform: translate(-50px, 20px) scale(1.08);\n  }\n}\n@keyframes drift3 {\n  to {\n    transform: translate(30px, -40px) scale(1.12);\n  }\n}\n\n@keyframes dash-flow {\n  to {\n    stroke-dashoffset: -1000;\n  }\n}\n\n@keyframes trace {\n  from {\n    stroke-dashoffset: 1200;\n  }\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n  }\n}\n\n/* =========================================================================\n   Responsive\n   ========================================================================= */\n\n@media (max-width: 960px) {\n  .hero-grid {\n    grid-template-columns: 1fr;\n    gap: var(--sp-6);\n  }\n  .hero-visual {\n    order: -1;\n  }\n  .steps,\n  .pricing-grid,\n  .pain-grid {\n    grid-template-columns: 1fr;\n  }\n  .corp-footer .cols {\n    grid-template-columns: 1fr 1fr;\n    gap: var(--sp-5);\n  }\n  .auth-screen {\n    grid-template-columns: 1fr;\n  }\n  .auth-aside {\n    display: none;\n  }\n}\n\n@media (max-width: 560px) {\n  .corp-footer .cols {\n    grid-template-columns: 1fr;\n  }\n  .detect-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 820px) {\n  .app-shell {\n    grid-template-columns: 1fr;\n  }\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 60;\n    transform: translateX(-100%);\n    transition: transform var(--dur) var(--ease);\n    width: var(--sidebar-w);\n    box-shadow: var(--shadow-lg);\n  }\n  .sidebar.open {\n    transform: translateX(0);\n  }\n  .app-body {\n    padding: var(--sp-4);\n  }\n  .nav-links .link {\n    display: none;\n  }\n}\n\n@media (max-width: 560px) {\n  .container {\n    padding: 0 var(--sp-4);\n  }\n  .hero {\n    padding: var(--sp-7) 0 var(--sp-6);\n  }\n  .section {\n    padding: var(--sp-7) 0;\n  }\n}\n\n.menu-btn {\n  display: none;\n  background: transparent;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--r-sm);\n  color: var(--text);\n  padding: 6px;\n  cursor: pointer;\n}\n@media (max-width: 820px) {\n  .menu-btn {\n    display: inline-grid;\n    place-items: center;\n  }\n}\n\n.scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 55;\n  backdrop-filter: blur(2px);\n}\n@media (min-width: 821px) {\n  .scrim {\n    display: none;\n  }\n}\n\n/* =========================================================================\n   Faz 8 — Zengin metrik paneli\n   ========================================================================= */\n\n.dash-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--sp-4);\n  flex-wrap: wrap;\n  margin-bottom: var(--sp-5);\n}\n.agent-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: var(--r-full);\n  border: 1px solid var(--border);\n  background: var(--glass);\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.agent-pill .ap-time {\n  color: var(--text-3);\n  font-weight: 400;\n  font-size: 12px;\n  padding-left: 6px;\n  border-left: 1px solid var(--border);\n}\n\n.health-card {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-6);\n  flex-wrap: wrap;\n  margin-bottom: var(--sp-4);\n}\n.health-body {\n  flex: 1;\n  min-width: 240px;\n}\n.health-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 1.05rem;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n.health-desc {\n  color: var(--text-3);\n  font-size: 0.9rem;\n  margin: 0 0 12px;\n  max-width: 44ch;\n}\n.health-drivers {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.health-drivers li {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--text-2);\n}\n.health-drivers .hd-pts {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-variant-numeric: tabular-nums;\n  color: var(--crit);\n  font-weight: 600;\n  min-width: 30px;\n  text-align: right;\n}\n.hd-clean {\n  font-size: 13px;\n  color: var(--ok);\n  margin: 0;\n}\n.health-spark {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-end;\n  font-size: 11px;\n  color: var(--text-3);\n}\n\n.schema-strip {\n  border: 1px solid var(--border);\n  border-radius: var(--r-md);\n  background: var(--glass);\n  margin-bottom: var(--sp-6);\n  overflow: hidden;\n}\n.schema-strip .ss-head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background: transparent;\n  border: 0;\n  color: var(--text-2);\n  font-family: inherit;\n  font-size: 13px;\n  cursor: pointer;\n}\n.schema-strip .ss-body {\n  padding: 0 14px 14px;\n  font-size: 12.5px;\n  color: var(--text-3);\n}\n.schema-strip .ss-body p {\n  margin: 0 0 10px;\n}\n.ss-missing {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n.ss-missing code {\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: var(--r-sm);\n  padding: 2px 7px;\n  font-size: 11.5px;\n}\n\n.metric-section {\n  margin-bottom: var(--sp-7);\n}\n.ms-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 0.92rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--text-2);\n  margin-bottom: var(--sp-4);\n}\n.ms-title svg { color: var(--text-3); }\n.ms-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--sp-4);\n}\n.ms-title-row .ms-title {\n  margin-bottom: 0;\n}\n\n.metric-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));\n  gap: var(--sp-3);\n}\n.mc-wrap.wide {\n  grid-column: span 2;\n}\n.mc-wrap {\n  display: flex;\n  flex-direction: column;\n}\n\n.metric-card {\n  background: var(--glass);\n  border: 1px solid var(--border);\n  border-radius: var(--r-md);\n  padding: var(--sp-4);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: 100%;\n  transition: border-color var(--dur) var(--ease), transform var(--dur) var(--ease);\n}\n.mc-wrap:hover .metric-card {\n  border-color: var(--border-strong);\n}\n.mc-wrap.wide .metric-card {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-bottom: 0;\n}\n.mc-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.mc-label {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12px;\n  color: var(--text-3);\n  font-weight: 500;\n  line-height: 1.3;\n}\n.mc-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.mc-delta {\n  font-size: 11.5px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.mc-delta.up { color: var(--ok); }\n.mc-delta.down { color: var(--crit); }\n.mc-delta.flat { color: var(--text-3); }\n.mc-value {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 1.55rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n.mc-spark {\n  margin-top: auto;\n}\n.mc-foot {\n  font-size: 11px;\n  color: var(--text-3);\n}\n.mc-detail {\n  border: 1px solid var(--border);\n  border-top: 0;\n  border-bottom-left-radius: var(--r-md);\n  border-bottom-right-radius: var(--r-md);\n  background: var(--surface);\n  padding: var(--sp-4);\n}\n\n/* MiniBars */\n.mb-track {\n  display: flex;\n  height: 12px;\n  border-radius: var(--r-full);\n  overflow: hidden;\n  background: var(--surface-2);\n}\n.mb-fill {\n  height: 100%;\n}\n.mb-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 16px;\n  margin-top: 10px;\n  font-size: 11.5px;\n  color: var(--text-3);\n}\n.mb-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.mb-legend i {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n}\n.mb-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.mb-row {\n  display: grid;\n  grid-template-columns: 68px 1fr auto;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n}\n.mb-row-label {\n  color: var(--text-3);\n}\n.mb-row-track {\n  height: 8px;\n  background: var(--surface-2);\n  border-radius: var(--r-full);\n  overflow: hidden;\n}\n.mb-row-val {\n  color: var(--text-2);\n  font-variant-numeric: tabular-nums;\n  font-size: 11.5px;\n}\n\n@media (max-width: 720px) {\n  .metric-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n  .mc-wrap.wide {\n    grid-column: 1 / -1;\n  }\n  .health-card {\n    gap: var(--sp-4);\n  }\n  .health-spark {\n    display: none;\n  }\n}\n\n/* =========================================================================\n   Yasal sayfalar\n   ========================================================================= */\n\n.legal-page {\n  padding: calc(var(--nav-h, 64px) + var(--sp-8)) 0 var(--sp-8);\n  max-width: 820px;\n  margin: 0 auto;\n}\n.legal-page .legal-back {\n  display: inline-block;\n  color: var(--text-3);\n  font-size: 13px;\n  margin-bottom: var(--sp-5);\n}\n.legal-page .legal-back:hover { color: var(--accent); }\n.legal-page h1 {\n  font-size: 2rem;\n  margin-bottom: 6px;\n}\n.legal-page .legal-updated {\n  color: var(--text-3);\n  font-size: 13px;\n  margin-bottom: var(--sp-5);\n}\n.legal-page .legal-intro {\n  color: var(--text-2);\n  font-size: 1rem;\n  line-height: 1.7;\n  padding-bottom: var(--sp-5);\n  border-bottom: 1px solid var(--border);\n  margin-bottom: var(--sp-6);\n}\n.legal-section {\n  margin-bottom: var(--sp-6);\n}\n.legal-section h2 {\n  font-size: 1.08rem;\n  margin-bottom: var(--sp-3);\n}\n.legal-section p {\n  color: var(--text-2);\n  font-size: 0.95rem;\n  line-height: 1.75;\n  margin-bottom: var(--sp-3);\n}\n.legal-section ul {\n  margin: var(--sp-2) 0 var(--sp-3) var(--sp-5);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.legal-section li {\n  color: var(--text-2);\n  font-size: 0.95rem;\n  line-height: 1.65;\n  list-style: disc;\n}\n.legal-nav {\n  display: flex;\n  gap: var(--sp-3);\n  flex-wrap: wrap;\n  padding-top: var(--sp-6);\n  border-top: 1px solid var(--border);\n  margin-top: var(--sp-7);\n}\n\n@media (max-width: 560px) {\n  .legal-page h1 { font-size: 1.5rem; }\n}\n\n/* =========================================================================\n   Faz 9 — Çoklu sunucu\n   ========================================================================= */\n\n/* Topbar sunucu seçici */\n.srv-switch { position: relative; }\n.srv-switch-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: var(--r-full);\n  border: 1px solid var(--border);\n  background: var(--glass);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  max-width: 200px;\n}\n.srv-switch-btn:hover { border-color: var(--border-strong); }\n.srv-switch-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.srv-switch-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  min-width: 240px;\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--r-md);\n  box-shadow: var(--shadow-lg);\n  padding: 6px;\n  z-index: 40;\n}\n.srv-switch-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: var(--r-sm);\n  background: transparent;\n  color: var(--text-2);\n  font-family: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  text-align: left;\n}\n.srv-switch-item:hover { background: var(--surface-2); color: var(--text); }\n.srv-switch-item.active { color: var(--text); background: var(--accent-soft); }\n.srv-switch-item span:nth-child(2) { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.srv-switch-foot {\n  display: flex;\n  gap: 4px;\n  border-top: 1px solid var(--border);\n  margin-top: 4px;\n  padding-top: 4px;\n}\n.srv-switch-foot button {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 7px 8px;\n  border: 0;\n  border-radius: var(--r-sm);\n  background: transparent;\n  color: var(--text-3);\n  font-family: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n.srv-switch-foot button:hover { background: var(--surface-2); color: var(--text); }\n\n.srv-tag {\n  font-size: 10.5px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: var(--r-full);\n  background: var(--surface-3);\n  color: var(--text-3);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n.srv-tag.warn { background: var(--warn-soft); color: var(--warn); }\n.srv-health {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  padding: 2px 7px;\n  border-radius: var(--r-full);\n  background: var(--ok-soft);\n  color: var(--ok);\n}\n.srv-health.warn { background: var(--warn-soft); color: var(--warn); }\n.srv-health.crit { background: var(--crit-soft); color: var(--crit); }\n\n/* Sunucularım listesi */\n.list-plain { display: flex; flex-direction: column; gap: var(--sp-3); }\n.srv-row { padding: 0; overflow: hidden; }\n.srv-row.is-suspended { opacity: 0.7; }\n.srv-row-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--sp-3);\n  padding: var(--sp-4);\n  flex-wrap: wrap;\n}\n.srv-row-body {\n  border-top: 1px solid var(--border);\n  padding: var(--sp-4);\n  background: var(--bg-1);\n}\n.srv-setup-warn {\n  color: var(--warn);\n  font-size: 12.5px;\n  margin: 0 0 12px;\n}\n.icon-btn {\n  display: inline-grid;\n  place-items: center;\n  width: 22px;\n  height: 22px;\n  border: 1px solid var(--border);\n  border-radius: var(--r-sm);\n  background: transparent;\n  color: var(--text-3);\n  cursor: pointer;\n}\n.icon-btn:hover { color: var(--accent); border-color: var(--border-strong); }\n\n/* Adet seçici */\n.qty-stepper {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--r-md);\n  overflow: hidden;\n}\n.qty-stepper button {\n  width: 38px;\n  height: 38px;\n  border: 0;\n  background: var(--surface-2);\n  color: var(--text);\n  font-size: 18px;\n  cursor: pointer;\n}\n.qty-stepper button:hover:not(:disabled) { background: var(--surface-3); }\n.qty-stepper button:disabled { opacity: 0.4; cursor: not-allowed; }\n.qty-stepper span {\n  min-width: 44px;\n  text-align: center;\n  font-family: \"Space Grotesk\", sans-serif;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n/* --- Büyüme / Reklam Atıf --- */\n.fld { display: flex; flex-direction: column; gap: 5px; font-size: 12px; }\n.fld > span { font-weight: 500; color: var(--text-2); }\n.fld input, .fld select {\n  width: 100%;\n  padding: 9px 11px;\n  border-radius: var(--r-md);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-1);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 13.5px;\n}\n.fld input:focus, .fld select:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n.growth-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: var(--sp-4);\n}\n.growth-summary > div { display: flex; flex-direction: column; gap: 3px; }\n.growth-summary span { font-size: 12px; color: var(--text-3); }\n.growth-summary strong {\n  font-family: \"Space Grotesk\", sans-serif;\n  font-size: 1.35rem;\n  font-variant-numeric: tabular-nums;\n}\n.growth-disclaimer { font-size: 12px; color: var(--text-3); margin: 8px 2px 0; }\n.growth-link {\n  display: flex; align-items: center; gap: 8px;\n  background: var(--bg-1); border: 1px solid var(--border);\n  border-radius: var(--r-md); padding: 8px 10px;\n  font-size: 12px; color: var(--text-2); overflow-x: auto;\n}\n.growth-link code { white-space: nowrap; font-family: ui-monospace, Menlo, monospace; }\n.growth-stats {\n  display: grid; grid-template-columns: repeat(auto-fit, minmax(90px, 1fr)); gap: 10px;\n  border-top: 1px solid var(--border); padding-top: 10px;\n}\n.growth-stats > div { display: flex; flex-direction: column; gap: 2px; }\n.growth-stats span { font-size: 11.5px; color: var(--text-3); }\n.growth-stats strong { font-variant-numeric: tabular-nums; font-size: 15px; }\n.growth-conf {\n  font-size: 10.5px; letter-spacing: 0.03em;\n  padding: 2px 7px; border-radius: 999px; font-weight: 600;\n}\n.growth-conf.estimated { background: var(--surface-2); color: var(--text-3); }\n.growth-conf.measured { background: var(--accent-soft); color: var(--accent); }\n.growth-roas {\n  display: flex; align-items: baseline; gap: 14px; flex-wrap: wrap;\n  border-top: 1px solid var(--border); padding-top: 10px;\n}\n.growth-roas > div:first-child { display: flex; flex-direction: column; gap: 2px; }\n.growth-roas span { font-size: 11.5px; color: var(--text-3); }\n.growth-roas strong { font-family: \"Space Grotesk\", sans-serif; font-size: 1.5rem; font-variant-numeric: tabular-nums; }\nstrong.pos { color: var(--ok); }\nstrong.neg { color: var(--crit); }\n.growth-summary strong.pos, .growth-summary strong.neg { font-family: \"Space Grotesk\", sans-serif; }\n\n.ag-tabs { display: flex; gap: 4px; }\n.ag-tabs button {\n  padding: 7px 14px; border: 1px solid var(--border); background: var(--surface);\n  color: var(--text-2); border-radius: var(--r-md); font: inherit; font-size: 13px; cursor: pointer;\n}\n.ag-tabs button.active { background: var(--accent-soft); color: var(--accent); border-color: var(--accent); font-weight: 600; }\n.ag-table { width: 100%; border-collapse: collapse; font-size: 13px; }\n.ag-table th, .ag-table td { text-align: left; padding: 10px 14px; border-bottom: 1px solid var(--border); white-space: nowrap; }\n.ag-table th { font-size: 11.5px; letter-spacing: 0.02em; color: var(--text-3); font-weight: 600; }\n.ag-table td { font-variant-numeric: tabular-nums; }\n.ag-table tbody tr:last-child td { border-bottom: 0; }\n.ag-table tbody tr:hover { background: var(--surface-2); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
